<template>
  <div class="commentItem">
    <div class="commentItem_userInfo">
      <el-avatar :size="30" :src="comment.user.avatarurl" v-if="comment.user.avatarurl"></el-avatar>
      <el-avatar :size="30" :src="require('@/assets/user_icon.jpeg')" v-else></el-avatar>

      <div class="commentItem_userInfo_name_view">
        <label class="commentItem_userInfo_name">
          {{comment.user.nickname}}
          <span style="color: #959595;" v-if="comment.replay_name">回复</span>
          <span class="commentItem_userInfo_name" v-if="comment.replay_name">{{comment.replay_name}}</span>
        </label>
      </div>

      <div class="commentItem_zai">
        <el-image
          style="width: 16px; height: 16px; margin-right: 2px;"
          :src="require('@/assets/community_zai.png')"
          fit="contain"
          lazy
        />
        <span class="commentItem_zai_text">{{comment.likecount}}</span>
      </div>
    </div>

    <span class="commentItem_content">{{comment.content}}</span>

    <el-row v-if="comment.imgs && comment.imgs.length > 0" class="commentItem_imageView">
      <el-image
        v-for="(image, index) in comment.imgs"
        :key="index"
        class="commentItem_imageView_image"
        :src="image.media"
        fit="cover"
        lazy
      />
    </el-row>
    <span class="commentItem_time">{{comment.create_at}}</span>
    <span style="background: #F3F3F3; height: 1px; margin-top: 14px; margin-bottom: 6px;" />
  </div>
</template>

<script>
export default {
  name: "comment",
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight // 屏幕高
    };
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.commentItem {
  display: flex;
  flex-direction: column;
}
.commentItem_userInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
}
.commentItem_userInfo_name_view {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
}
.commentItem_userInfo_name {
  color: #2497f7;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  whitewhite-space: nowrap;
}
.commentItem_zai {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.commentItem_zai_text {
  color: #a6b4bf;
  font-size: 14px;
}
.commentItem_content {
  color: #242424;
  font-size: 16px;
  line-height: 26px;
  margin-top: 6px;
  white-space: pre-wrap;
}
.commentItem_time {
  color: #959595;
  font-size: 12px;
  margin-top: 6px;
}
.commentItem_imageView {
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
}
.commentItem_imageView_image {
  width: 100px;
  height: 100px;
  margin-top: 5px;
  margin-right: 10px;
  /* :style="{width: screenWidth / 3 + 'px', height: screenWidth / 3 + 'px'}" */
}
</style>



// WEBPACK FOOTER //
// src/components/BlogComment.vue